import React, { FC, useState } from 'react';

import { CuiOptionType, Dropdown } from '@crehana/ui';

import { useTranslation } from '@crehana/i18n';

import { CountryPrefix } from 'Jsx/global';

import { CheckoutTKeys } from 'Jsx/CheckoutV4/i18n/language';

import { DocumentTypeEnum } from 'Jsx/Types/Graphql/globals.payments';

import getCountryPrefix from 'Utils/getCountryPrefix';

import InputField, { InputState } from '../InputField';

import { getCountryProps } from './utils';
import { DocumentState } from './types';

type Props = {
  countryPrefix?: CountryPrefix;
  onChange: (value: DocumentState) => void;
  required?: boolean;
};

const DocumentInput: FC<Props> = ({
  countryPrefix = getCountryPrefix(),
  onChange,
  required,
}) => {
  const { t } = useTranslation<CheckoutTKeys>();
  const { label, mask, validation, documentTypes, inputMode } =
    getCountryProps(countryPrefix);
  const [documentType, setDocumentType] = useState<DocumentTypeEnum | null>(
    documentTypes.length === 1 && documentTypes[0] ? documentTypes[0] : null,
  );

  const handleOnChange = ({ maskedValue, isValid }: InputState) => {
    onChange({
      document: maskedValue,
      isValid,
      documentType,
    });
  };

  const handleDropdownChange = (
    selected: CuiOptionType<DocumentTypeEnum> | undefined,
  ) => {
    if (selected) setDocumentType(selected?.value || null);
  };

  return (
    <div className="mb-24">
      {documentTypes.length > 1 && (
        <Dropdown<DocumentTypeEnum>
          options={documentTypes.map(document => ({
            label: document,
            value: document,
          }))}
          label={t('DOCUMENT_TYPE_LABEL')}
          selected={
            documentType
              ? { value: documentType, label: documentType }
              : undefined
          }
          hint={t('DOCUMENT_DROPDOWN_HINT')}
          full
          onSelected={handleDropdownChange}
          className="mb-24"
        />
      )}
      <InputField
        onChange={handleOnChange}
        label={label}
        mask={mask}
        validation={validation}
        disabled={!documentType}
        required={required}
        inputMode={inputMode}
        disabledMessage={t('DOCUMENT_DROPDOWN_HINT')}
      />
    </div>
  );
};

export default DocumentInput;
